import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { OrderConfirmationItemsComponent } from '@spartacus/order/components';

@Component({
  selector: 'cx-order-confirmation-items',
  templateUrl: './gonvarri-order-confirmation-items.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GonvarriOrderConfirmationItemsComponent extends OrderConfirmationItemsComponent {
  // Empty class to override the default OrderConfirmationItemsComponent, providing only modifications to the HTML template
}
